import { useCallback, useEffect } from 'react';
import { useOfflineContext } from 'contexts/OfflineContext/OfflineContext';
import { useDebouncedCallback } from './useDebouncedCallback';

export const useNetworkStatus = () => {
  const { isOnline, setIsOnline, showOfflineAlert, setShowOfflineAlert } = useOfflineContext();

  const updateAlertStatus = useDebouncedCallback((show: boolean) => {
    setShowOfflineAlert(show);
  }, 3000);

  const handleOnline = useCallback(() => {
    setIsOnline(true);
    updateAlertStatus(false);
  }, [setIsOnline, updateAlertStatus]);

  const handleOffline = useCallback(() => {
    setIsOnline(false);
    updateAlertStatus(true);
  }, [setIsOnline, updateAlertStatus]);

  useEffect(() => {
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [handleOnline, handleOffline]);

  const dismissAlert = useCallback(() => {
    setShowOfflineAlert(false);
  }, [setShowOfflineAlert]);

  return { isOnline, showOfflineAlert, dismissAlert };
};
